import React from "react";
import { useLanguage } from "../../contexts/LanguageContext";
import { V2, pickLang } from "../copy";
import { Eyebrow, Words } from "./Primitives";

const ManifestoV2: React.FC = () => {
  const { currentLanguage } = useLanguage();
  const c = V2[pickLang(currentLanguage)].manifesto;

  return (
    <section className="bg-bone py-24 text-ink sm:py-36">
      <div className="mx-auto max-w-[1400px] px-4 sm:px-6">
        <Eyebrow index="01">{c.label}</Eyebrow>

        <p
          data-words
          className="mt-8 max-w-5xl font-display text-[clamp(2rem,5.4vw,5.25rem)] leading-[1.02] tracking-[-0.02em]"
        >
          <Words text={c.text} />
        </p>

        <div className="mt-16 grid gap-px border border-ink/10 bg-ink/10 sm:grid-cols-3">
          {c.principles.map(([n, title, desc], i) => (
            <div
              key={n}
              className="v2-reveal bg-bone p-6 sm:p-8"
              data-delay={String(i + 1)}
            >
              <div className="font-mono text-[11px] tracking-[0.22em] text-teal-deep">
                {n}
              </div>
              <h3 className="mt-6 text-lg font-medium tracking-tight sm:text-xl">
                {title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-ink/60">{desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ManifestoV2;
